var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"poster widget",class:{ active: _vm.active }},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"wrapper"},[_c('Display',{attrs:{"model":_vm.model,"image":true}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }